import React from 'react';
import { Button, Switch, message } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import useDocumentStore from '../stores/documentStore';
import './DocumentAccessControl.css';

function DocumentAccessControl({ documentId }) {
  const { 
    isPublic, 
    publicUrl, 
    isPublicLoading,
    enablePublicAccess,
    disablePublicAccess
  } = useDocumentStore();

  const handlePublicToggle = async (checked) => {
    try {
      if (checked) {
        await enablePublicAccess(documentId);
        message.success('Доступ по ссылке включен');
      } else {
        await disablePublicAccess(documentId);
        message.success('Доступ по ссылке выключен');
      }
    } catch (error) {
      message.error('Ошибка при изменении доступа');
    }
  };

  return (
    <div className="document-access-control">
      <div className="document-access-control__access-controls">
        <span className="document-access-control__title">Доступ по ссылке</span>
        <Switch
          checked={isPublic}
          onChange={handlePublicToggle}
          loading={isPublicLoading}
        />
      </div>
    </div>
  );
}

export default DocumentAccessControl; 
